/** @format */

import React, { useState } from 'react'
import { putData } from '../../../../../../../Helpers/webApi'
import swal from 'sweetalert2'
import ModalTemplate from '../../../../../../../Components/ModalTemplate/ModalTemplate'
import localize from '../../../../../../../Global/Localize'
import EnumsServerCombo from '../../../../../../../Components/ComboBox/EnumsServerCombo'
import { ApprovePurchaseRequisitionModal } from './ApprovePurchaseRequisitionModal'

export const PurchaseRequisitionModal = ({
  mode,
  onHideModal,
  loading,
  onUpdateRefreshAt,
  onSetMode,
  selectedPurchaseRequisition,
  setSelectedPurchaseRequisition,
}) => {
  const [isBusy, setIsBusy] = useState(false)

  async function handleSubmit() {
    if (mode === 'approve') {
      approveRequisition()
    }
  }

  const approveRequisition = async () => {
    setIsBusy(true)
    const { success, data } = await putData(
      '/WorkFlow/approve-purchase-requisition-workflow-item',
      {
        ...selectedPurchaseRequisition,
      },
      false,
    )
    if (success) {
      onSetMode(null)
      onUpdateRefreshAt()
      setSelectedPurchaseRequisition(null)
      swal.fire(
        'Approve Purchase Requisition',
        'Operation Completed Successfully',
        'success',
      )
    }
    setIsBusy(false)
  }

  return (
    <>
      <>
        {mode && (
          <ModalTemplate
            modalMode={mode}
            modalTitle={localize('purchaseRequisition')}
            handleAction={handleSubmit}
            handleClose={onHideModal}
            footerChildren={
              <div className="d-flex align-content-end justify-content-end">
                <div className="col d-flex align-items-center me-5">
                  <label className="col-3 text-capitalize me-4">
                    {localize('remarks')}
                  </label>
                  <input
                    className="form-control"
                    value={selectedPurchaseRequisition?.remarks}
                    onChange={e => {
                      setSelectedPurchaseRequisition({
                        ...selectedPurchaseRequisition,
                        remarks: e.target.value,
                      })
                    }}
                  />
                </div>
                <div className="col d-flex align-items-center ms-2">
                  <EnumsServerCombo
                    value={selectedPurchaseRequisition?.approvalOption}
                    onChange={e => {
                      setSelectedPurchaseRequisition({
                        ...selectedPurchaseRequisition,
                        approvalOption: e.value,
                      })
                    }}
                    customContainerStyle={{ width: '100%' }}
                    enumsKey="WorkflowApprovalOption"
                  />
                </div>
              </div>
            }
            hideUpdate={mode === 'view'}
            disableCreate={isBusy}
            modalClassName={'modal-xl'}
          >
            {mode === 'approve' && (
              <ApprovePurchaseRequisitionModal
                isBusy={loading || isBusy}
                selectedPurchaseRequisition={selectedPurchaseRequisition}
              />
            )}
          </ModalTemplate>
        )}
      </>
    </>
  )
}
